module.exports = __webpack_public_path__ + "img/daily_1.c97adbc7.png";